<template>
  <Dialog v-model:open="isAlertOpen">
    <DialogContent class="sm:max-w-[425px]">
      <div class="relative">
        <div>
          <h3
            class="text-center font-bold text-base md:text-xl lg:text-2xl leading-8 text-text-content"
          >
            {{ $t("Remove-Design", "Remove Design") }}
          </h3>
          <div
            class="text-center text-xs md:text-sm font-normal text-text-secondary md:mt-1"
          >
            {{ $t("confirmRemoveDesign") }}
          </div>
        </div>
        <div class="flex mt-4 w-full gap-x-3">
          <Button variant="outline" class="w-full" @click="isAlertOpen = false">
            {{ $t("cancel", "Cancel") }}
          </Button>
          <Button class="w-full" @click="handleRemove">
            {{ $t("remove", "Remove") }}
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
</template>

<script setup>
import { ref, watch, defineEmits } from "vue";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import Button from "../ui/button/Button.vue";
import { useSubscription } from "@vueuse/rxjs";
import { openDeleteModal, closeDeleteModal } from "@/lib/utils.js";

const isAlertOpen = ref(false);

const emits = defineEmits(["update:open", "delete"]);

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
});

watch(
  () => props.open,
  (newVal) => {
    isAlertOpen.value = newVal;
  },
);

useSubscription(
  openDeleteModal.subscribe(() => {
    isAlertOpen.value = true;
    emits("update:open", true);
  }),
  closeDeleteModal.subscribe(() => {
    isAlertOpen.value = false;
    emits("update:open", false);
  }),
);

const handleRemove = () => {
  emits("delete");
  emits("update:open", false);
};
</script>
